import React from "react";
import CertificateBox from "./certificate-box";
import { GET_STATISTICS_QUERY } from "queries/queries";
import { useQuery } from '@apollo/client';
import Error from "../error";
import Loading from "../loading";
import NoResultPage from "components/thankyou/noresult-page";
import useMakeScrollable from "custom_hooks/make-scrollable";

export const Certificates = () => {
  useMakeScrollable()
  const { loading, error, data } = useQuery(GET_STATISTICS_QUERY, {
    fetchPolicy: "no-cache",
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  const certificates = data?.statistics?.certificates || [];

  return (
    <div className="scrollable">
      {certificates.length ? (
        <div className="certificate">
          <div className="certificate-container">
            {certificates.map((certificate) => (
              <CertificateBox
                key={certificate.id}
                name={certificate.name}
                url={certificate.url}
                certificateId={certificate.id}
                target="_blank"
              />
            ))}
          </div>
        </div>
      ) : (
        <NoResultPage
         text={'Es sind leider keine Zertifikate vorhanden, die angezeigt werden können.'}
        />
      )}
    </div>
  );
};